import { SUPPORT_EMAIL, SUPPORT_PHONE } from "../../config";
import { Link } from "react-router-dom";
import { logoDark } from "../../assets/";
import CallToAction from "../CTA/CallToAction";
import NewsLetter from "../integrations/Newsletter";
import useAppData from "../../hooks/useAppData";

const Footer = () => {
	const currentYear = new Date().getFullYear();
	const { settings, categories } = useAppData();

	return (
		<footer className="bg-black text-white relative z-20">
			{/* CTA Section */}
			<div className="bg-brand-500">
				<CallToAction />
			</div>

			{/* Main Footer Content */}
			<div className="max-w-7xl mx-auto px-4 py-12">
				{/* Main Flex Container */}
				<div className="flex flex-col lg:flex-row flex-wrap justify-between gap-12">
					{/* 1. Newsletter Section */}
					<div className="flex-1 min-w-70 lg:max-w-75 space-y-5">
						<img className="h-auto max-w-37.5 pb-2" src={logoDark} alt="logo" />
						<h5 className="font-bold text-2xl tracking-tight">
							Stay Connected
						</h5>
						<p className="text-lg text-gray-400 leading-relaxed">
							Subscribe to get latest news, offers and logistic insight -
							straight to your inbox
						</p>
						<div className="pt-2">
							<NewsLetter />
						</div>
					</div>

					{/* 2. Services Section */}
					<div className="flex-2 min-w-75">
						<h5 className="font-bold text-2xl underline decoration-brand-500 underline-offset-12 mb-10">
							Our Services
						</h5>
						<div className="grid grid-cols-2 gap-x-8 gap-y-4 text-lg">
							<ul className="space-y-4">
								{categories
									?.slice(0, Math.ceil((categories.length + 2) / 2))
									.map((category) => (
										<li key={category.id} className="group flex items-center">
											<span className="w-0 h-0.5 bg-brand-500 transition-all duration-300 gh:w-3 gh:mr-2"></span>
											<Link
												to={`/services/${category.slug}`}
												className="text-gray-400 gh:text-white transition-colors duration-200"
											>
												{category.title}
											</Link>
										</li>
									))}
							</ul>
							<ul className="space-y-4">
								{categories
									?.slice(Math.ceil((categories.length + 2) / 2))
									.map((category) => (
										<li key={category.id} className="group flex items-center">
											<span className="w-0 h-0.5 bg-brand-500 transition-all duration-300 gh:w-3 gh:mr-2"></span>
											<Link
												to={`/services/${category.slug}`}
												className="text-gray-400 gh:text-white transition-colors duration-200"
											>
												{category.title}
											</Link>
										</li>
									))}
								<li className="group flex items-center">
									<span className="w-0 h-0.5 bg-brand-500 transition-all duration-300 gh:w-3 gh:mr-2"></span>
									<Link
										to="/privacy-policy"
										className="text-gray-400 gh:text-white transition-colors duration-200"
									>
										Privacy Policy
									</Link>
								</li>
								<li className="group flex items-center">
									<span className="w-0 h-0.5 bg-brand-500 transition-all duration-300 gh:w-3 gh:mr-2"></span>
									<Link
										to="/terms-condition"
										className="text-gray-400 gh:text-white transition-colors duration-200"
									>
										Terms & Conditions
									</Link>
								</li>
							</ul>
						</div>
					</div>

					{/* 3. Useful Links Section */}
					<div className="flex-1 min-w-62.5 lg:max-w-[320px]">
						<h5 className="font-bold text-2xl underline decoration-brand-500 underline-offset-8 mb-8">
							Useful Links
						</h5>
						<ul className="space-y-4 text-lg">
							<li className="group flex items-center">
								<span className="w-0 h-0.5 bg-brand-500 transition-all duration-300 gh:w-3 gh:mr-2"></span>
								<Link
									to="/about-us"
									className="text-gray-400 gh:text-white transition-colors duration-200"
								>
									About us
								</Link>
							</li>
							<li className="group flex items-center">
								<span className="w-0 h-0.5 bg-brand-500 transition-all duration-300 gh:w-3 gh:mr-2"></span>
								<Link
									to="/contact-us"
									className="text-gray-400 gh:text-white transition-colors duration-200"
								>
									Contact us
								</Link>
							</li>
							<li className="flex flex-col text-gray-400">
								<span className="text-xs uppercase tracking-widest text-brand-500 mb-1">
									Email
								</span>
								<Link
									to={`mailto:${settings?.email || SUPPORT_EMAIL}`}
									className="text-white"
								>
									{settings?.email || SUPPORT_EMAIL}
								</Link>
							</li>
							<li className="flex flex-col text-gray-400">
								<span className="text-xs uppercase tracking-widest text-brand-500 mb-1">
									Phone
								</span>
								<Link
									to={`tel:${settings?.phone_number || SUPPORT_PHONE}`}
									className="text-white"
								>
									{settings?.phone_number || SUPPORT_PHONE}
								</Link>
							</li>
							<li className="pt-2 text-sm italic text-brand-500 border-t border-gray-800">
								Sat - Fri: 10:00 am - 8:00 pm
							</li>
						</ul>
					</div>
				</div>
			</div>

			{/* Bottom Bar */}
			<hr className="border-gray-700" />
			<div className="max-w-7xl mx-auto px-4 py-6">
				<p className="text-center text-md text-white/75">
					&copy; {currentYear} Blue Dart Express Freight Brokers L.L.C.
					<br /> All rights reserved.
				</p>
			</div>
		</footer>
	);
};

export default Footer;
